import { render, staticRenderFns } from "./CsRevisionTarifasTrabajos.vue?vue&type=template&id=6770195a"
import script from "./CsRevisionTarifasTrabajos.vue?vue&type=script&lang=js"
export * from "./CsRevisionTarifasTrabajos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports